import React, { Component } from 'react';
import { View, TouchableOpacity, Text, StyleSheet, } from 'react-native';
import { AdEventKey, } from '@zattoo/playback-sdk';
import { EventKey, } from '@zattoo/playback-sdk-zapi';
const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        bottom: 80,
        right: 20,
        zIndex: 1000,
    },
    skipButton: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 4,
        borderWidth: 1,
        borderColor: 'white',
    },
    skipButtonText: {
        color: 'white',
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    countdownButton: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 4,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.5)',
    },
    countdownText: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
    },
});
export class SkipAdButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSkipButton: false,
            skipTimeOffset: 0,
            isAdPlaying: false,
            currentPosition: 0,
        };
    }
    componentDidMount() {
        // Listen to ad events
        this.props.player.on(AdEventKey.AD_LOADED, this.onAdLoaded);
        this.props.player.on(AdEventKey.AD_POSITION_CHANGED, this.onAdPositionChanged);
        this.props.player.on(AdEventKey.AD_BREAK_STARTED, this.onAdBreakStarted);
        this.props.player.on(AdEventKey.AD_BREAK_ENDED, this.onAdBreakEnded);
        this.props.player.on(AdEventKey.AD_ENDED, this.onAdEnded);
        this.props.player.on(EventKey.MEDIA_CHANGED, this.onMediaChanged);
    }
    componentWillUnmount() {
        // Remove event listeners
        this.props.player.off(AdEventKey.AD_LOADED, this.onAdLoaded);
        this.props.player.off(AdEventKey.AD_POSITION_CHANGED, this.onAdPositionChanged);
        this.props.player.off(AdEventKey.AD_BREAK_STARTED, this.onAdBreakStarted);
        this.props.player.off(AdEventKey.AD_BREAK_ENDED, this.onAdBreakEnded);
        this.props.player.off(AdEventKey.AD_ENDED, this.onAdEnded);
        this.props.player.off(EventKey.MEDIA_CHANGED, this.onMediaChanged);
    }
    onAdLoaded = (event) => {
        const adInfo = event.data.adInfo;
        if (adInfo && adInfo.skipTimeOffset && adInfo.skipTimeOffset > 0) {
            this.setState({
                skipTimeOffset: adInfo.skipTimeOffset,
            });
        }
    };
    onAdPositionChanged = (event) => {
        const position = event.data.position;
        // Update current position
        this.setState({
            currentPosition: position,
        });
        // Show skip button if position is greater than skipTimeOffset
        const shouldShowSkip = this.state.isAdPlaying &&
            this.state.skipTimeOffset > 0 &&
            position >= this.state.skipTimeOffset;
        if (shouldShowSkip !== this.state.showSkipButton) {
            this.setState({
                showSkipButton: shouldShowSkip,
            });
        }
    };
    onAdBreakStarted = () => {
        this.setState({
            isAdPlaying: true,
        });
    };
    onAdBreakEnded = () => {
        this.setState({
            isAdPlaying: false,
            showSkipButton: false,
            skipTimeOffset: 0,
            currentPosition: 0,
        });
    };
    onAdEnded = () => {
        this.setState({
            showSkipButton: false,
            skipTimeOffset: 0,
            currentPosition: 0,
        });
    };
    onMediaChanged = () => {
        // Reset state on media change
        this.setState({
            showSkipButton: false,
            skipTimeOffset: 0,
            isAdPlaying: false,
            currentPosition: 0,
        });
    };
    onSkipPress = () => {
        // Access the adapter and call requestAdSkip
        if (this.props.player && this.props.player.requestAdSkip) {
            this.props.player.requestAdSkip();
        }
    };
    render() {
        const { showSkipButton, skipTimeOffset, isAdPlaying, currentPosition, } = this.state;
        // Don't show anything if ad is not playing or no skip time offset
        if (!isAdPlaying || skipTimeOffset <= 0) {
            return null;
        }
        // Show skip button if skip time has been reached
        if (showSkipButton) {
            return (React.createElement(View, { style: styles.container },
                React.createElement(TouchableOpacity, { style: styles.skipButton, onPress: this.onSkipPress, activeOpacity: 0.8 },
                    React.createElement(Text, { style: styles.skipButtonText }, "Skip Ad"))));
        }
        // Show countdown if skip time hasn't been reached yet
        const remainingTime = skipTimeOffset - currentPosition;
        const countdownSeconds = Math.round(Math.max(0, remainingTime));
        if (countdownSeconds > 0) {
            return (React.createElement(View, { style: styles.container },
                React.createElement(View, { style: styles.countdownButton },
                    React.createElement(Text, { style: styles.countdownText },
                        "Skip in ",
                        countdownSeconds,
                        "s"))));
        }
        return null;
    }
}
